import {
  FETCH_COLLECTION_PAGE_NECKLACE_FIELDS,
  TOGGLE_COLLECTION_PAGE_NECKLACE_OVERLAY,
} from "../actions/types";

const INITIAL_STATE = {
  pageTitleText: "",
  overlayTitleText: "",
  overlayDescriptionText: "",
  overlayButtonText: "",
  selectButtonText: "",
  collectionLinkText: "",
  collectionLinkURL: "",
  backButtonText: "",
  showOverlay: true,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_COLLECTION_PAGE_NECKLACE_FIELDS:
      if (action.payload.items) {
        return {
          ...state,
          pageTitleText: action.payload.items[0].fields.pageTitleText,
          overlayTitleText: action.payload.items[0].fields.overlayTitleText,
          overlayDescriptionText:
            action.payload.items[0].fields.overlayDescriptionText,
          overlayButtonText: action.payload.items[0].fields.overlayButtonText,
          selectButtonText: action.payload.items[0].fields.selectButtonText,
          collectionLinkText: action.payload.items[0].fields.collectionLinkText,
          collectionLinkURL: action.payload.items[0].fields.collectionLinkUrl,
          backButtonText: action.payload.items[0].fields.backButtonText,
        };
      }
      return state;
    case TOGGLE_COLLECTION_PAGE_NECKLACE_OVERLAY:
      return { ...state, showOverlay: !state.showOverlay };
    default:
      return state;
  }
};
